/*
 * sfc-color-preview.js — Sept 16 2026
 *
 * Big colour preview for the Colored Epoxy Resin Kit page (and PP-80).
 * Loaded by snippets/variant-picker.liquid only on the handles listed in
 * sfc_dot_handles there. Hovering a colour tile fills the main product
 * image area with that colour; clicking a tile pins it until the shopper
 * taps the panel, a thumbnail or a gallery arrow, or picks another colour.
 *
 * Reads data-sfc-color / data-sfc-name off the Color tiles, which the
 * snippet renders from value.swatch.color. Pure overlay — it never touches
 * the gallery's own markup or variant-picker.js, and it survives the
 * section re-render that happens on every variant change.
 */
(function () {
  'use strict';

  var pinned = null; // { color: 'rgb(...)', name: 'Dove Gray' } or null
  var panel = null;
  var scheduled = false;

  function viewer() {
    return document.querySelector('media-gallery .media-gallery__viewer');
  }

  function ensurePanel() {
    var v = viewer();
    if (!v) return null;
    if (panel && panel.parentNode === v) return panel;
    panel = v.querySelector('.sfc-color-preview');
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'sfc-color-preview';
      panel.setAttribute('aria-hidden', 'true');
      panel.innerHTML = '<span class="sfc-color-preview__name"></span>' +
        '<span class="sfc-color-preview__hint">Click to see the kit</span>';
      panel.addEventListener('click', function () {
        pinned = null;
        hide();
      });
      v.appendChild(panel);
    }
    return panel;
  }

  function show(color, name) {
    var p = ensurePanel();
    if (!p) return;
    p.style.background = color;
    p.querySelector('.sfc-color-preview__name').textContent = name;
    p.classList.add('is-visible');
  }

  function hide() {
    if (pinned) { show(pinned.color, pinned.name); return; }
    if (panel) panel.classList.remove('is-visible');
  }

  function tiles() {
    return document.querySelectorAll('.sfc-big-swatches label[data-sfc-color]');
  }

  function bind() {
    var list = tiles();
    for (var i = 0; i < list.length; i++) {
      var l = list[i];
      if (l.getAttribute('data-sfc-bound')) continue;
      l.setAttribute('data-sfc-bound', '1');
      l.addEventListener('mouseenter', onEnter);
      l.addEventListener('mouseleave', onLeave);
      l.addEventListener('click', onClick);
    }
    // After a section re-render the panel is gone; restore the pinned colour.
    if (pinned) show(pinned.color, pinned.name);
  }

  function onEnter(e) {
    var l = e.currentTarget;
    show(l.getAttribute('data-sfc-color'), l.getAttribute('data-sfc-name'));
  }

  function onLeave() { hide(); }

  function onClick(e) {
    var l = e.currentTarget;
    pinned = { color: l.getAttribute('data-sfc-color'), name: l.getAttribute('data-sfc-name') };
    show(pinned.color, pinned.name);
  }

  // Any click inside the gallery that is not on the panel itself (thumbnail,
  // arrow, zoom) means the shopper wants the photo back.
  document.addEventListener('click', function (e) {
    if (!pinned) return;
    var g = e.target.closest ? e.target.closest('media-gallery') : null;
    if (g && !(e.target.closest('.sfc-color-preview'))) {
      pinned = null;
      hide();
    }
  }, true);

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; bind(); }, 60);
  }

  function init() {
    if (!tiles().length) return;
    bind();
    var mo = new MutationObserver(schedule);
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
